import { eachDayOfInterval, interval } from 'date-fns';
import { DatesRangeCriteria } from '../entities';
import { weekdaysDateFilter } from './dates-filter';

export function datesFromRange(criteria: DatesRangeCriteria | null | undefined) {
  const start = criteria?.start;
  const end = criteria?.end;

  if (!start || !end) return [];

  return eachDayOfInterval(interval(start, end)).filter((date) =>
    weekdaysDateFilter(criteria)(date),
  );
}
